export const ESTATUS = [
  {
    id: 1,
    name: 'ACTIVO',
    value: 'true',
  },
  {
    id: 2,
    name: 'INACTIVO',
    value: 'false',
  },
];
export const ESTATUS_BOOLEAN = [
  {
    id: 1,
    name: 'Activo',
    value: true,
  },
  {
    id: 2,
    name: 'Inactivo',
    value: false,
  },
];

export const ESTATUS_SELECT = [
  {
    id: 0,
    name: 'Todos',
    value: '',
  },
  {
    id: 1,
    name: 'Activo',
    value: 'true',
  },
  {
    id: 2,
    name: 'Inactivo',
    value: 'false',
  },
];

export const ESTATUS_EMISION = {
  VIGENTE: 'VIGENTE',
};
